import routerOptions0 from "/data/runners/gh1205/_work/apps-monorepo/apps-monorepo/node_modules/.pnpm/nuxt@3.21.10_@oxc-project+types@0.140.0_@parcel+watcher@2.5.6_@types+node@26.1.2_@vue+c_16621045e53f933fd4b5094b9abc67e1/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}